// extracted by mini-css-extract-plugin
export default {"timerActive":"Timer_timerActive__wxuUG","timer":"Timer_timer__NiuSn"};